import { useMutationUpdateUser, usersQueryKey } from "@apis:user/user";
import { SuperInput } from "@components:SuperInput/SuperInput";
import { useInvalidateQueries } from "@hooks:useInvalidateQueries";
import { useUser } from "@libs:react-query-auth";
import { Box, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Header } from "@pages:settings/Header";
import { useToasterStoreActions } from "@stores:global";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { UserUpdateSchemaWritable } from "@:openapi";

export const Profile = () => {
  const invalidateQueries = useInvalidateQueries();
  const toastActions = useToasterStoreActions();
  const { t } = useTranslation();
  const user = useUser().data;
  const [email, setEmail] = useState(user!.email);
  const [name, setName] = useState(user!.name);

  const [password, setPassword] = useState("");

  const updateMeMutation = useMutationUpdateUser({
    onSettled: async () => {
      setPassword("");
      await invalidateQueries.run([
        {
          queryKey: usersQueryKey.me.queryKey,
        },
      ]);
    },
    onError: () => {
      toastActions.setToaster({
        open: true,
        message: t("settings.profile.updateFailed"),
        variant: "error",
      });
    },
    onSuccess: () => {
      toastActions.setToaster({
        open: true,
        message: t("settings.profile.updated"),
        variant: "success",
      });
    },
  });

  const handleUpdateMe = async (params: UserUpdateSchemaWritable) => {
    await updateMeMutation.mutateAsync({
      id: user!.id,
      ...params,
    });
  };

  return (
    <Box
      className="Settings__Profile__Details"
      sx={{
        width: "100%",
      }}
    >
      <Header />
      <Box
        sx={{
          mx: "auto",
          maxWidth: "30rem",
        }}
      >
        <Box className={"Settings__Profile__Details__Basics"}>
          <Typography
            sx={{
              marginTop: "2rem",
              fontSize: "1.2rem",
              fontWeight: "bold",
            }}
          >
            {t("settings.profile.general")}
          </Typography>

          <Box
            sx={{
              marginTop: "1rem",
            }}
          >
            <SuperInput.TextField
              label={t("settings.profile.fullName")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <SuperInput.TextField
              sx={{
                marginTop: "1rem",
              }}
              label={t("common.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              variant="contained"
              sx={{
                marginTop: "1rem",
              }}
              onClick={async () => {
                await handleUpdateMe({
                  name,
                  email,
                });
              }}
            >
              {t("common.save")}
            </Button>
          </Box>

          <Box
            className={"Settings__Profile__Details__Password"}
            sx={{
              mt: "4rem",
            }}
          >
            <Typography
              sx={{
                marginTop: "2rem",
                fontSize: "1.2rem",
                fontWeight: "bold",
              }}
            >
              {t("settings.profile.changePassword")}
            </Typography>

            <Box
              sx={{
                marginTop: "1rem",
              }}
            >
              <SuperInput.TextField
                sx={{
                  marginTop: "1rem",
                }}
                label={t("settings.profile.newPassword")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />

              <Button
                variant="contained"
                sx={{
                  marginTop: "1rem",
                }}
                onClick={async () => {
                  await handleUpdateMe({
                    password,
                  });
                }}
              >
                {t("common.save")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
